import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message = _resolveComponent("message")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    columns: _ctx.columns,
    rows: _ctx.filteredUsers,
    selection: "multiple",
    selected: _ctx.selected,
    "selected-rows-label": _ctx.selectedLabel,
    loading: _ctx.isLoading,
    "rows-per-page-options": [0],
    flat: "",
    "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:selected', $event)))
  }, {
    "no-data": _withCtx(() => [
      _withDirectives(_createVNode(_component_message, { class: "full-width" }, {
        default: _withCtx(() => [
          _createTextVNode(" Client is assigned to every user. ")
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.isLoading]
      ])
    ]),
    _: 1
  }, 8, ["columns", "rows", "selected", "selected-rows-label", "loading"]))
}